import { CloseIcon } from "@chakra-ui/icons";
import { Flex, Text, Button } from "@chakra-ui/react";
import { t } from "i18next";
import { FunnelComponentProps } from "../../funnel/types";

export function PurchasePodModalHeader({ onClose }: FunnelComponentProps) {
  return (
    <Flex
      flexDirection="row"
      justifyContent="space-between"
      width="100%"
      p="16px 24px"
    >
      <Text fontFamily="heading" fontSize="20px" fontWeight="600">
        {t("components.payments.pod.buyPhysicalEdition")}
      </Text>
      <Button
        alignSelf="center"
        variant="iconOnly"
        onClick={onClose}
        minWidth={0}
      >
        <CloseIcon alignSelf="center" color="dune.100" />
      </Button>
    </Flex>
  );
}
